module.exports = __webpack_public_path__ + "media/PAG90-01.7d473242.mp3";